import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/learning-map/tutorial.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "absolute right-4 top-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "arraste"
  })
], -1)
const _hoisted_2 = { class: "w-full h-[65vh] relative" }
const _hoisted_3 = {
  ref: "titleLabel",
  id: "title-label",
  class: "z-50 bg-white hidden justify-center items-center flex-col absolute rounded-md shadow-md p-2"
}
const _hoisted_4 = { ref: "titleP" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", {
    id: "faceCircle",
    clipPathUnits: "objectBoundingBox"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "0.5",
      cy: "0.5",
      r: "0.5"
    })
  ])
], -1)
const _hoisted_6 = ["r"]
const _hoisted_7 = ["x", "y", "width", "height", "xlink:href"]
const _hoisted_8 = ["r"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_MaterialModal = _resolveComponent("MaterialModal")!
  const _component_v_network_graph = _resolveComponent("v-network-graph")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.nodesAndTrails?.chapters?.length === 0 && !_ctx.loader)
      ? (_openBlock(), _createBlock(_component_EmptyData, {
          key: 0,
          data: _ctx.nodesAndTrails?.chapters?.length === 0 && !_ctx.loader,
          title: _ctx.emptyState.title,
          label: _ctx.emptyState.description,
          image: _ctx.emptyState.image,
          imgSize: "h-40 my-10"
        }, null, 8, ["data", "title", "label", "image"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "learning-map",
          class: _normalizeClass(`w-full z-10  cursor-grab active:cursor-grabbing relative ${
        _ctx.user.role === 'STUDENT' ? 'bg-h-primary-50' : 'bg-white'
      }`)
        }, [
          _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"]),
          _hoisted_1,
          (_ctx.configModal.showMaterials)
            ? (_openBlock(), _createBlock(_component_MaterialModal, {
                key: 0,
                showMaterialsModal: _ctx.configModal.showMaterials,
                materials: _ctx.materials,
                learningObjective: _ctx.learningObjective,
                config: _ctx.configModal,
                onOnCloseMaterialsModal: _ctx.closeMaterialsModal,
                onOnChooseMaterial: _ctx.chooseMaterial
              }, null, 8, ["showMaterialsModal", "materials", "learningObjective", "config", "onOnCloseMaterialsModal", "onOnChooseMaterial"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, null, 512)
            ], 512),
            _createVNode(_component_v_network_graph, {
              ref: "graph",
              class: "graph",
              configs: _ctx.configs,
              nodes: _ctx.nodes,
              edges: _ctx.edges,
              layouts: _ctx.layouts,
              "event-handlers": _ctx.eventHandlers()
            }, {
              "override-node": _withCtx(({ nodeId, ...slotProps }) => [
                _createElementVNode("circle", _mergeProps({
                  class: "face-circle",
                  r: `${_ctx.nodes[nodeId].width / 2}`,
                  fill: "#00000000"
                }, slotProps), null, 16, _hoisted_6),
                _createElementVNode("image", {
                  class: _normalizeClass(`face-picture ${
                _ctx.nodes[nodeId].type != 'material'
                  ? 'cursor-default'
                  : 'cursor-pointer'
              }`),
                  x: _ctx.nodes[nodeId].x,
                  y: _ctx.nodes[nodeId].y,
                  width: _ctx.nodes[nodeId].width,
                  height: _ctx.nodes[nodeId].height,
                  "xlink:href": `${_ctx.nodes[nodeId].face}`,
                  "clip-path": "url(#faceCircle)"
                }, null, 10, _hoisted_7),
                _createElementVNode("circle", _mergeProps({
                  class: "face-circle",
                  r: `${_ctx.nodes[nodeId].width / 2}`,
                  fill: "none"
                }, slotProps), null, 16, _hoisted_8)
              ]),
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["configs", "nodes", "edges", "layouts", "event-handlers"])
          ])
        ], 2))
  ]))
}